export const SYNC_PUSH_DEBOUNCE_MS = 1_000;

/**
 * Wraps an async function so a burst of calls collapses into a single
 * invocation `delayMs` after the last one - used so a flurry of local
 * edits (e.g. someone typing, or several settings changed in a row)
 * triggers one push instead of one per edit.
 */
export const debounce = (
  fn: () => Promise<void>,
  delayMs: number,
  onError: (error: unknown) => void
): (() => void) => {
  let handle: ReturnType<typeof setTimeout> | undefined;

  return () => {
    if (handle) clearTimeout(handle);
    handle = setTimeout(() => {
      handle = undefined;
      void fn().catch(onError);
    }, delayMs);
  };
};
